import { ItemInfo } from "../models/item";
import { PartnerInvestmentRecord } from "../models/partnerInvestment";

export const getInvestmentCodeForItem = (
	item: ItemInfo,
	investments: PartnerInvestmentRecord[]
): string | null => {
	const itemKey = item.itemCode;
	const match = investments.find((investment) =>
		(investment.itemLinks || []).some((link) => link.itemCode === itemKey)
	);

	return match?.code?.trim() || null;
};
